export default {
  getListLibrary (state) {
    return state.libraries
  },
  getListTrash (state) {
    return state.librariesTrash
  },

  getLibraryDoc (state) {
    return state.librariesDoc
  }
}



// WEBPACK FOOTER //
// ./src/store/module/library/getters.js